
export enum SalaryActionTypes {
    FILL_TABLE = 'FILL_TABLE',
    SET_OPTION = 'SET_OPTION',
    EDIT_TABLE = 'EDIT_TABLE',
    CREATE_TRANSFER = 'CREATE_TRANSFER',
    GET_SALARY_LIST = 'GET_SALARY_LIST',
    GET_SALARY_LIST_WITH_FIN = 'GET_SALARY_LIST_WITH_FIN',
    GET_SALARY_LIST_SUCCESS = 'GET_SALARY_LIST_SUCCESS',
    GET_SALARY_LIST_ERROR = 'GET_SALARY_LIST_ERROR',
    CLEAR_SALARY_LIST = 'CLEAR_SALARY_LIST',
}
export interface SalaryState {
    tableValue?: Array<any>,
    selectedItem?: Array<string>,
    editedTableValue?: Array<any>,
    createdTransferValue?: Array<any>,
    salaryList?: Array<any>,
    salaryListError?: boolean,
    searchbyfin?: boolean,
}
interface SalaryFillTableAction {
    type: SalaryActionTypes.FILL_TABLE,
    payload: []
}
interface SalaryEditTableAction {
    type: SalaryActionTypes.EDIT_TABLE,
    payload: []
}
interface SetSelectedItemAction {
    type: SalaryActionTypes.SET_OPTION,
    payload: []
}
interface SetSelectedCreateTransferAction {
    type: SalaryActionTypes.CREATE_TRANSFER,
    payload: []
}
interface GetSalaryListAction {
    type: SalaryActionTypes.GET_SALARY_LIST,
}

interface GetSalaryListWithFinAction {
    type: SalaryActionTypes.GET_SALARY_LIST_WITH_FIN,
}

interface GetSalaryListSuccessAction {
    type: SalaryActionTypes.GET_SALARY_LIST_SUCCESS,
    payload: any
}
interface GetSalaryListErrorAction {
    type: SalaryActionTypes.GET_SALARY_LIST_ERROR,
}

interface ClearSalaryListAction {
    type: SalaryActionTypes.CLEAR_SALARY_LIST,
}


export type SalaryAction = SalaryFillTableAction | SetSelectedItemAction | SalaryEditTableAction | SetSelectedCreateTransferAction | GetSalaryListAction | GetSalaryListSuccessAction | GetSalaryListErrorAction | ClearSalaryListAction | GetSalaryListWithFinAction

